import { render, staticRenderFns } from "./TranppassBIJuridico.vue?vue&type=template&id=12681e75&"
import script from "./TranppassBIJuridico.vue?vue&type=script&lang=js&"
export * from "./TranppassBIJuridico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports